import { AllPlans as Plans } from '@/plans';
import { isDevEnv } from '@/utils';
import { BillingCycleEnum } from '../constants';
import { includes, filter } from 'lodash';
import { PLAN_PRICE_CHANGE_UTILS } from '@/common/priceChange';
import store from '@/store';
import { logger } from "@/utils/log";

export function verifyPlanItemField() {
  const _verify = obj => {
    const requireField = ['type', 'category', 'plan_code', 'cartInfo', 'amount', 'billing_cycle', 'supportCoupon', 'dependBasePlanTypeList', 'typeNameKey'];
    const missKey = requireField.find(k => !Reflect.has(obj, k));
    if(missKey) {
      throw new Error(`${obj.type} miss key: ${missKey}`);
    }
    return obj;
  }

  return plans => {
    if(isDevEnv) {
      const _plansProxy = new Proxy(plans, {
        set(target, k, v) {
          if(!isNaN(Number(k,10)) && v) {
            _verify(v);
          }
          return Reflect.set(target, k, v);
        },
      });
      return _plansProxy;
    }
    return plans;
  }
}

export function plansDataMapper(planMapJSON, subscriptions = []) {
  const _planMapFlat = verifyPlanItemField()([]);
  Plans.forEach(p => {
    if(p.pre) {
      const res = p.pre(planMapJSON, this, subscriptions);
      if(res) {
        _planMapFlat.push(...res);
      }
    }
  });
  const list = _planMapFlat.map(item => ({
    ...item,
    cycleValue: BillingCycleEnum[item.billing_cycle] || -1,
    isOnline: true,
  }));
  store.commit('setPlanMapFlatRaw', [...list]);
  return list;
}

export function loadSelectByPersist(persist) {
  return function (planMapFlat) {
    if(!persist) {
      return planMapFlat;
    }

    return planMapFlat.map(item => {
      const planCode = item.plan_code;
      let cartInfo = persist[planCode];

      // PRO INCREASE
      if (PLAN_PRICE_CHANGE_UTILS.isConsiderPriceChangeCase(planCode)) {
        const mappingPlanCode = PLAN_PRICE_CHANGE_UTILS.getOtherPlanCodeForPriceChange(planCode);
        cartInfo = cartInfo ?? persist[mappingPlanCode];
      }
      const mapResultItem = {
        ...item,
        cartInfo: cartInfo || item.cartInfo,
      }

      return mapResultItem
    });
  }
}

export function filterCapacity (capacityList = {}) {
  return (planMapFlat = []) => {
    return filter(planMapFlat, (p) => {
      return capacityList[p.type] && !p.isPPA ? includes(capacityList[p.type],p.capacity) : p
    });
  };
};

export function buildShoppingCartWithPersist(allPlans, persist) {
  if (!persist) {
    logger.log('buildShoppingCartWithPersist: error', 'cache is empty');
    return null
  }
  const nextPlans = loadSelectByPersist(persist)(allPlans);
  const selectedPlans = nextPlans.filter(item => item.cartInfo?.selected_number > 0)
  if (!selectedPlans.length) {
    logger.log('buildShoppingCartWithPersist: error', 'cache is invalid');
    return null
  }
  logger.log('buildShoppingCartWithPersist: selectedPlans:', selectedPlans);
  return nextPlans;
}
